/**
 * Cache staleTime Strategy
 * ========================
 *
 * Centralised staleTime constants for React Query / TanStack Query.
 *
 * Categories:
 *  - STATIC    (10 min) -- Data that rarely changes during a session:
 *                          categories, brands, site config, schema registry.
 *  - FREQUENT  (1 min)  -- Data that changes moderately and should stay
 *                          reasonably fresh: notifications, cart, badges.
 *  - REALTIME  (30 s)   -- Data that needs near-real-time freshness:
 *                          messaging threads, live analytics dashboards.
 *  - DEFAULT   (1 min)  -- Fallback for queries that do not fit a specific
 *                          category. Matches FREQUENT for a safe middle ground.
 *
 * Usage:
 *   import { STALE_TIME_STATIC } from '@/shared/constants/cacheConfig';
 *   useQuery({ queryKey: ['categories'], queryFn: fetchCategories, staleTime: STALE_TIME_STATIC });
 */

/** 10 minutes -- categories, brands, config, schema registry */
export const STALE_TIME_STATIC = 10 * 60 * 1000;

/** 1 minute -- notifications, cart, badges */
export const STALE_TIME_FREQUENT = 60 * 1000;

/** 30 seconds -- messaging, live analytics */
export const STALE_TIME_REALTIME = 30 * 1000;

/** 1 minute -- default for most queries */
export const STALE_TIME_DEFAULT = 60 * 1000;
